<template>
  <v-card
    class="card-hover pa-0 d-flex flex-column align-center"
    :class="[colorSet, $vuetify.breakpoint.mobile ? 'mb-2' : 'ma-0']"
    elevation="0"
    height="260"
    width="183"
    outlined
    @click="$emit('click')"
  >
    <v-card-text class="d-flex flex-column align-center px-5 py-5">
      <div class="d-flex align-center justify-center icon-square mb-3 mt-3">
        <v-icon color="white">{{ icon }}</v-icon>
      </div>
      <p
        class="subtitle-2 font-weight-bold blue-grey--text text--darken-3 mb-2 text-center"
        style="line-height: 20px;"
      >
        {{ title }}
      </p>
      <p class="caption text-center">{{ description }}</p>
    </v-card-text>

    <v-card-actions style="position:absolute; bottom:0">
      <p class="font-bold blue--text">
        {{ $t('common.create') }}
      </p>
    </v-card-actions>
  </v-card>
</template>

<script>
const BACKGROUND_COLORS = {
  improvementIdea: 'improvement-idea-colors',
  quickAction: 'quick-action-colors',
  problemSolving: 'problem-solving-colors',
  challenge: 'challenge-colors',
  recognition: 'recognition-colors',
  task: 'task-colors-new',
}

const TYPES = [
  'improvementIdea',
  'quickAction',
  'problemSolving',
  'challenge',
  'task',
  'recognition',
]

export default {
  name: 'TypeCard',

  props: {
    type: {
      type: String,
      validator: val => {
        return TYPES.includes(val)
      },
    },
    icon: {
      type: String,
    },
    description: {
      type: String,
    },
    title: {
      type: String,
    },
  },

  computed: {
    colorSet() {
      return BACKGROUND_COLORS[this.type]
    },
  },
}
</script>
<style lang="scss" scoped>
.icon-square {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.improvement-idea-colors {
  .icon-square {
    background: $color-gradient-blue;
  }
}
.quick-action-colors {
  .icon-square {
    background: $color-gradient-orange;
  }
}
.problem-solving-colors {
  .icon-square {
    background: $color-gradient-pink;
  }
}
.challenge-colors {
  .icon-square {
    background: $color-gradient-purple;
  }
}
.task-colors-new {
  .icon-square {
    background: $color-gradient-green;
  }
}

.recognition-colors {
  .icon-square {
    background: $color-gradient-yellow;
  }
}
</style>
